import PropTypes from "prop-types"
import React from "react"

import Form from "src/components/Form"
import HeadingPageTitle from "src/components/Heading/HeadingPageTitle"
import Loader from "src/components/Loader"
import StripeConnectContainer from "src/components/StripeConnect/StripeConnectContainer"

const BankTab = ({
  handleAccountCreated,
  handleOnboardingSuccess,
  isSessionLoading,
  onboardingRequiredFieldsComplete,
  sessionError,
  smaCountries,
  stripeConnectInstance,
  stripeManagedAccountId,
}) => {
  return (
    <div className="flex justify-center">
      <div className="card w-full shadow-base 2xl:w-1/2">
        <div className="mb-6 flex flex-col space-y-2">
          <HeadingPageTitle>
            {onboardingRequiredFieldsComplete
              ? "Stripe Account Management"
              : "Stripe Account Setup"}
          </HeadingPageTitle>
          <p className="text-gray-600">
            {onboardingRequiredFieldsComplete
              ? "Manage your Stripe account settings and banking information."
              : "Enable secure payment processing through Stripe in order to accept bookings and payments from boaters."}
          </p>
        </div>

        {isSessionLoading ? (
          <Loader />
        ) : sessionError ? (
          <Form.Error>{sessionError.message}</Form.Error>
        ) : (
          <StripeConnectContainer
            stripeManagedAccountId={stripeManagedAccountId}
            smaCountries={smaCountries}
            mode={
              onboardingRequiredFieldsComplete ? "management" : "onboarding"
            }
            onSuccess={handleOnboardingSuccess}
            onUpdate={handleAccountCreated}
            onAccountCreated={handleAccountCreated}
            onboardingRequiredFieldsComplete={onboardingRequiredFieldsComplete}
            stripeConnectInstance={stripeConnectInstance}
          />
        )}
      </div>
    </div>
  )
}

BankTab.propTypes = {
  stripeConnectInstance: PropTypes.object,
  onboardingRequiredFieldsComplete: PropTypes.bool,
  isSessionLoading: PropTypes.bool.isRequired,
  sessionError: PropTypes.object,
  stripeManagedAccountId: PropTypes.string,
  smaCountries: PropTypes.arrayOf(
    PropTypes.shape({
      countryCode: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
    })
  ).isRequired,
  handleOnboardingSuccess: PropTypes.func.isRequired,
  handleAccountCreated: PropTypes.func.isRequired,
}

export default BankTab
